/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const phoneCustomerSettingsResponseOutputVersionExclusiveMin = 0;
export const phoneCustomerSettingsResponseOutputVersionMax = 9007199254740991;

export const phoneCustomerSettingsResponseOutputClientCodeMin = 4;
export const phoneCustomerSettingsResponseOutputClientCodeMax = 4;

export const phoneCustomerSettingsResponseOutputClientCodeRegExp = new RegExp('^[0-9]{4}$');
export const phoneCustomerSettingsResponseOutputRecognizedCallerGreetingOneTwoTextMax = 400;

export const phoneCustomerSettingsResponseOutputRecognizedCallerGreetingOneThreeAssetIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const phoneCustomerSettingsResponseOutputCustomerIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const phoneCustomerSettingsResponseOutputAssetsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const phoneCustomerSettingsResponseOutputAssetsItemOwnerIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const phoneCustomerSettingsResponseOutputAssetsItemSizeBytesExclusiveMin = 0;
export const phoneCustomerSettingsResponseOutputAssetsItemSizeBytesMax = 1048576;

export const phoneCustomerSettingsResponseOutputAssetsItemDurationMsExclusiveMin = 0;
export const phoneCustomerSettingsResponseOutputAssetsItemDurationMsMax = 60000;

export const phoneCustomerSettingsResponseOutputAssetsItemDigestRegExp = new RegExp(
  '^[a-f0-9]{64}$',
);
export const phoneCustomerSettingsResponseOutputAssetsMax = 1;

export const PhoneCustomerSettingsResponseOutput = zod.object({
  version: zod
    .int()
    .gt(phoneCustomerSettingsResponseOutputVersionExclusiveMin)
    .max(phoneCustomerSettingsResponseOutputVersionMax),
  clientCode: zod
    .string()
    .min(phoneCustomerSettingsResponseOutputClientCodeMin)
    .max(phoneCustomerSettingsResponseOutputClientCodeMax)
    .regex(phoneCustomerSettingsResponseOutputClientCodeRegExp),
  recognizedCallerGreeting: zod.union([
    zod.union([
      zod.object({
        mode: zod.literal('default'),
      }),
      zod.object({
        mode: zod.literal('tts'),
        text: zod
          .string()
          .min(1)
          .max(phoneCustomerSettingsResponseOutputRecognizedCallerGreetingOneTwoTextMax),
      }),
      zod.object({
        mode: zod.literal('mp3'),
        assetId: zod
          .uuid()
          .regex(phoneCustomerSettingsResponseOutputRecognizedCallerGreetingOneThreeAssetIdRegExp),
      }),
    ]),
    zod.null(),
  ]),
  customerId: zod.uuid().regex(phoneCustomerSettingsResponseOutputCustomerIdRegExp),
  status: zod.enum(['active', 'archived']),
  assets: zod
    .array(
      zod.object({
        id: zod.uuid().regex(phoneCustomerSettingsResponseOutputAssetsItemIdRegExp),
        ownerType: zod.enum(['team', 'customer']),
        ownerId: zod.uuid().regex(phoneCustomerSettingsResponseOutputAssetsItemOwnerIdRegExp),
        slot: zod.enum([
          'inboundGreeting',
          'clientCodePrompt',
          'beforeTransfer',
          'voicemailPrompt',
        ]),
        mimeType: zod.literal('audio/mpeg'),
        sizeBytes: zod
          .int()
          .gt(phoneCustomerSettingsResponseOutputAssetsItemSizeBytesExclusiveMin)
          .max(phoneCustomerSettingsResponseOutputAssetsItemSizeBytesMax),
        durationMs: zod
          .int()
          .gt(phoneCustomerSettingsResponseOutputAssetsItemDurationMsExclusiveMin)
          .max(phoneCustomerSettingsResponseOutputAssetsItemDurationMsMax),
        digest: zod.string().regex(phoneCustomerSettingsResponseOutputAssetsItemDigestRegExp),
      }),
    )
    .max(phoneCustomerSettingsResponseOutputAssetsMax),
});

export type PhoneCustomerSettingsResponseOutput = zod.input<
  typeof PhoneCustomerSettingsResponseOutput
>;
export type PhoneCustomerSettingsResponseOutputOutput = zod.output<
  typeof PhoneCustomerSettingsResponseOutput
>;
